
import { defineComponent, computed, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import KTAside from '@/layout/aside/trainee/Aside.vue';
import KTHeader from '@/layout/header/Header.vue';
import KTFooter from '@/layout/footer/Footer.vue';
import HtmlClass from '@/core/services/LayoutService';
import KTScrollTop from '@/layout/extras/ScrollTop.vue';
import KTUserMenu from '@/layout/header/partials/ActivityDrawer.vue';
import KTLoader from '@/components/Loader.vue';
import KTCreateApp from '@/components/modals/wizards/CreateAppModal.vue';
import KTDrawerMessenger from '@/layout/extras/DrawerMessenger.vue';
import KTTraineeListDrawer from '@/layout/header/partials/trainee/TraineeEditDrawer.vue';
import CertificateEditModal from '@/layout/header/partials/trainee/certificateDrawer.vue';
import KTphotoUpdateDrawer from '@/layout/header/partials/trainee/photoUpdateDrawer.vue';
import KTBankInfoDrawer from '@/layout/header/partials/trainee/BankInfoDrawer.vue';
import KTLicenseDrawer from '@/layout/header/partials/trainee/LicenseInfoDrawer.vue';
import KTTraineeInfoEditDrawer from '@/layout/header/partials/trainee/TraineeInfoEditDrawer.vue';
import KTTraineeInfoDrawer from '@/layout/header/partials/trainee/trainee_infoDrawer.vue';
import KTTraineeCertificate from '@/layout/header/partials/trainee/uploadCertificateData.vue';
import { Actions } from '@/store/enums/StoreEnums';
import {
  MenuComponent,
  DrawerComponent,
  ScrollComponent,
} from '@/assets/ts/components/index';
import { removeModalBackdrop } from '@/core/helpers/dom';
import {
  toolbarDisplay,
  loaderEnabled,
  contentWidthFluid,
  loaderLogo,
  asideEnabled,
  subheaderDisplay,
  themeLightLogo,
  themeDarkLogo,
} from '@/core/helpers/config';

export default defineComponent({
  name: 'Layout',
  components: {
    KTAside,
    KTHeader,
    KTFooter,
    KTScrollTop,
    KTCreateApp,
    KTUserMenu,
    KTDrawerMessenger,
    KTTraineeListDrawer,
    KTLoader,
    KTphotoUpdateDrawer,
    KTBankInfoDrawer,
    KTLicenseDrawer,
    KTTraineeInfoEditDrawer,
    KTTraineeInfoDrawer,
    KTTraineeCertificate,
    CertificateEditModal,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    // show page loading
    store.dispatch(Actions.ADD_BODY_CLASSNAME, 'page-loading');

    // initialize html element classes
    HtmlClass.init();

    const pageTitle = computed(() => {
      return store.getters.pageTitle;
    });

    const breadcrumbs = computed(() => {
      return store.getters.pageBreadcrumbPath;
    });

    onMounted(() => {
      //check if current user is authenticated
      if (!store.getters.isUserAuthenticated) {
        router.push({ name: 'sign-in' });
      }

      DrawerComponent.bootstrap();
      ScrollComponent.bootstrap();
      DrawerComponent.updateAll();
      ScrollComponent.updateAll();

      // Simulate the delay page loading
      setTimeout(() => {
        // Remove page loader after some time
        store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading');
      }, 500);
    });

    watch(
      () => route.path,
      () => {
        MenuComponent.hideDropdowns(undefined);

        DrawerComponent.hideAll();

        // check if current user is authenticated
        if (!store.getters.isUserAuthenticated) {
          router.push({ name: 'sign-in' });
        }

        removeModalBackdrop();
      }
    );

    return {
      toolbarDisplay,
      loaderEnabled,
      contentWidthFluid,
      loaderLogo,
      asideEnabled,
      subheaderDisplay,
      pageTitle,
      breadcrumbs,
      themeLightLogo,
      themeDarkLogo,
    };
  },
});
